import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { GetState, SetState } from '../state/createState';
import { createOnSlotClickAction } from './onSlotClick/onSlotClick';
import { createOnFiltersChangeAction } from './onFiltersChange/onFiltersChange';
import { Filter } from '../../../types/types';
import { createOnTimeZoneChangeAction } from './onTimeZoneChange/onTimeZoneChange';
import { createOnWeekChangeAction } from './onWeekChange/onWeekChange';
import { createOnLoadMoreAction } from './onLoadMore/onLoadMore';
import { createOnDaySelectedAction } from './onDaySelected/onDaySelected';
import { DailyAgendaBiLogger } from '../../../utils/bi/biLogger';
import { createOnDialogCloseAction } from './onDialogClose/onDialogClose';
import { createOnDialogConfirmAction } from './onDialogConfirm/onDialogConfirm';

export type DailyAgendaActions = {
  onFiltersChange: (newSelectedFilters: Filter[]) => Promise<void>;
  onSlotClick: (slotId: string) => Promise<void>;
  onTimeZoneChange: (timezoneId: string) => Promise<void>;
  onWeekChange: (range: { from: string; to: string }) => Promise<void>;
  onLoadMore: () => Promise<void>;
  onDaySelected: (selectedDay: string) => Promise<void>;
  onDialogClose: () => Promise<void>;
  onDialogConfirm: () => Promise<void>;
};

export type DailyAgendaActionFactory<ActionFN extends Function> = (args: {
  setState: SetState;
  getState: GetState;
  flowAPI: ControllerFlowAPI;
  biLogger: DailyAgendaBiLogger;
}) => ActionFN;

export const createDailyAgendaActions = (args: {
  setState: SetState;
  getState: GetState;
  flowAPI: ControllerFlowAPI;
  biLogger: DailyAgendaBiLogger;
}): DailyAgendaActions => ({
  onLoadMore: createOnLoadMoreAction(args),
  onWeekChange: createOnWeekChangeAction(args),
  onSlotClick: createOnSlotClickAction(args),
  onFiltersChange: createOnFiltersChangeAction(args),
  onTimeZoneChange: createOnTimeZoneChangeAction(args),
  onDaySelected: createOnDaySelectedAction(args),
  onDialogClose: createOnDialogCloseAction(args),
  onDialogConfirm: createOnDialogConfirmAction(args),
});
